import { render, staticRenderFns } from "./ChildrenTree.vue?vue&type=template&id=3bb8cb43&"
import script from "./ChildrenTree.vue?vue&type=script&lang=js&"
export * from "./ChildrenTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports